import { render } from "./NewClient.vue?vue&type=template&id=ff4358b8&scoped=true"
import script from "./NewClient.vue?vue&type=script&lang=js"
export * from "./NewClient.vue?vue&type=script&lang=js"

import "./NewClient.vue?vue&type=style&index=0&id=ff4358b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff4358b8"]])

export default __exports__